import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';
import type { SVGIcon } from '../SVGIcon';
import { SVGStyles } from '../SVGStyles';

export const CustomIcon = ({ height = 18, 'data-test': dataTest }: Readonly<SVGIcon>) => {
  const theme = useTheme();
  return (
    <SvgIcon viewBox="0 0 18 18" data-test={dataTest} sx={{ ...SVGStyles, width: 18, height }}>
      <path
        d="M10 6V4H13V0H15V4H18V6H10ZM13 18V8H15V18H13ZM3 18V14H0V12H8V14H5V18H3ZM3 10V0H5V10H3Z"
        fill={theme.palette.text.secondary}
      />
    </SvgIcon>
  );
};
